import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommencementCheckListType } from "../../Types/ChecklistTypes/CommencementCheckListType";
import { getAllCommencementChecklist } from "../../Thunks/CheckListThunks";

interface CommencementChecklistSliceState {
  loader: boolean; // for refres pages and inital loadings
  commencementChecklistData: CommencementCheckListType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: CommencementChecklistSliceState = {
  loader: false,
  commencementChecklistData: [],
  errorDisplay: "",
};

// handle api responces
const commencementChecklistSlice = createSlice({
  name: "commencementChecklistSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllCommencementChecklist.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllCommencementChecklist.pending, (state) => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(
        getAllCommencementChecklist.fulfilled,
        (state, action: PayloadAction<CommencementCheckListType[]>) => {
          state.loader = false;
          state.commencementChecklistData = action.payload;
        }
      );
  },
});

export const {} = commencementChecklistSlice.actions;
export default commencementChecklistSlice.reducer;
